import { useEffect } from "react";
import { clearMultiViewSelection } from "./selection-store";

/** The two pages the ticks belong to: Prep, and the screen it opens. */
const PAGES = ["/prep", "/multi-view"];

export function keepsSelection(pathname: string): boolean {
  return PAGES.some((page) => pathname === page || pathname.startsWith(`${page}/`));
}

/**
 * Mount on Prep and on Multi View. When either unmounts and the user has not
 * landed on the other, the ticks are cleared, so a later visit starts empty.
 * Checked a tick later, once the router has moved: at unmount time the address
 * can still be the old page's, and React's strict-mode remount in development
 * passes through here too without leaving the page.
 */
export function useMultiViewSelectionLifecycle() {
  useEffect(
    () => () => {
      setTimeout(() => {
        if (!keepsSelection(window.location.pathname)) clearMultiViewSelection();
      }, 0);
    },
    [],
  );
}
